export const ARTICLE_TOP_BANNER_HEIGHT = {
  DESKTOP: 64,
  TABLET: 64,
  MOBILE: 88,
};
